import gql from "graphql-tag";

const GET_POOL_QUIZ_QUESTION = gql`
    query getPoolQuizQuestion(
        $poolId: String!,
        $quizId: String!,
        $questionId: String!
    ) {
        getPoolQuizQuestion (
            getQuizQuestionInput: {
                poolId: $poolId,
                quizId: $quizId,
                questionId: $questionId,
            }
        ) {
            id
            orderNumber
            question
            answers {
                id
                orderNumber
                isCorrect
                answer
            }
        }
    }
`

export default GET_POOL_QUIZ_QUESTION;